export const getBarSize = (chartWidth: number, dataCount = 1) =>
  (chartWidth - 3 * (dataCount - 1)) / dataCount
